<template>
  <b-modal size="sm" :id="'modal-add-consumption' + detail.id" :title="detail.code + ' | ' + detail.benefit" ok-only hide-footer no-close-on-backdrop>
    <div class="isCentered isSpinner" v-if="isSaving">
        <center>
          <b-spinner class="isCentered" label="Spinning"></b-spinner> <br>
            Acción en proceso
        </center>
      </div> 
    <validation-observer ref="addConsumption" tag="form" v-slot="{ invalid }">	    
      <b-form @submit.prevent="saveConsumption(consumption)">         
        <b-row class="mb-2">
          <b-col>
            <ValidationProvider rules="required" name="cantidad">
              <b-form-group label="Cantidad" slot-scope="{ valid, errors }">
                <b-form-input
                  class="form-control"
                  type="number"
                  step="any"
                  placeholder="Agrege cantidad"
                  v-model="consumption.quantity"
                  @input="correctBalance(consumption.quantity)"
                  :state="errors[0] ? false : valid ? true : null"
                >
                </b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col md="12">
            <ValidationProvider rules="required" name="Fecha">
              <b-form-group label="Fecha de Operación" slot-scope="{ valid, errors }">
                <b-form-input                            
                  type="date"
                  :min="initialDate"
                  :max="detail.enddate"
                  :state="errors[0] ? false : valid ? true : null"
                  v-model="consumption.date"
                />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col md="12">
            <ValidationProvider rules="required" name="Notas">
              <b-form-group label="Notas del consumo">
                <b-form-textarea
                  v-model="consumption.note"
                  placeholder="Escribe la nota"
                  :maxlength="100"
                  rows="2"
                >
                </b-form-textarea>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <b-col md="12">
            <div class="text-right">
              <b-button :disabled="invalid || !validbalance || isSaving" variant="primary" type="submit">Guardar</b-button>              
            </div>
          </b-col>

        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"
import { utils } from '@/modules/fivesClub/mixins/utils'
import { heightFade } from '@core/directives/animations'
import { showAlertMessage, toDecimal, currentDate } from '@/helpers/helpers' 
import * as moment from 'moment'
import { acl } from "@/modules/auth/mixins/acl"

export default {
  mixins: [utils, acl],
  directives: {
    heightFade
  },
  props: {
    detail: {
      type: Object,
      required: true,
    },
    idContract: {
      type: Number,
      required: true,
    },
    isLoadingTransactions: {
      type: Function,
      required: true,
    },
    validateTransactionDate: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isSaving: false,
      consumption:{
        quantity: 0,
        note: '',
        date: '',
      },
      datenow: new Date(),
      validbalance: true
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    initialDate(){
      let currentDate = moment().startOf('day')
      if (this.can("fivesclub_contracts_can_add_transactions_before_today")) {
        currentDate = currentDate.add(-6, "months")
        if (moment(this.detail.initialdate).isBefore(moment(), 'year')) currentDate = moment(this.detail.initialdate).startOf('day')
      }
			return currentDate.format("YYYY-MM-DD")
    },
  },
  methods: {
    ...mapActions('fivesClubContracts', ['saveDetailTransactions', 'fetchTransactionsDetail','fetchTransactions']),
    ...mapMutations('fivesClubContracts', ['setTransactions','setDetailTransactions']),
    async saveConsumption(data) {
      this.isSaving = true
      const { quantity, note, date } = data
      const validDate = this.validateTransactionDate(date)
      if (!validDate) {
        this.isSaving = false
        return showAlertMessage('No se puede añadir el consumo', 'InfoIcon', 'No puede añadir un consumo en fechas anteriores' , 'warning', 4000, 'bottom-right' )
      }
      const payload = { id: this.detail.id, quantity: parseFloat(quantity), idUser: this.user.idUser, note, date, type: 1 }
      const { status, message } = await this.saveDetailTransactions(payload)
      if(status){
        showAlertMessage('Proceso terminado', 'InfoIcon', `Se ha guardado el registro: ${message}` , 'success', 4000, 'bottom-right' )
      } else {
        showAlertMessage('Error', 'InfoIcon', `Proceso terminado: ${message || ''}` , 'danger', 4000, 'bottom-right' )
      }
      const info = { id: this.idContract, year: this.datenow.getFullYear() }
      const infoDetail = { id: this.detail.id }
      this.isLoadingTransactions(false)
      const transactions = await this.fetchTransactions(info)
      this.setTransactions(transactions)

      const detailTransactions = await this.fetchTransactionsDetail(infoDetail)
      this.setDetailTransactions(detailTransactions)

      this.consumption.quantity = 0
      this.consumption.note = ''
      this.consumption.date = ''      
      this.$root.$emit("bv::hide::modal", "modal-add-consumption" + this.detail.id)
      this.isLoadingTransactions(false)
      this.isSaving = false
    },
    correctBalance(value){
      const number = Number(toDecimal(value))
      const balance = Number(this.detail.balance)
      if (number > balance){
        showAlertMessage('Error', 'InfoIcon', 'El valor debe ser menor al balance', 'danger', 4000, 'bottom-right' )
        this.validbalance = false
        this.$root.$emit("bv::hide::modal", "modal-add-consumption" + this.detail.id)
        this.consumption.quantity = 0
      } else if (number < 0){
        showAlertMessage('Error', 'InfoIcon', 'El valor no debe ser negativo', 'danger', 4000, 'bottom-right' )
        this.validbalance = false
        this.$root.$emit("bv::hide::modal", "modal-add-consumption" + this.detail.id)
        this.consumption.quantity = 0
      } else this.validbalance = true
    }
  },
};
</script>